import {
    BrowserRouter as Router,
    Routes,
    Route, useParams
} from 'react-router-dom';

import MaplibreMapWithId from './pages/MaplibreMapWithId';
import MapboxMapWithId from './pages/MapboxMapWithId';

const MapContainer: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/maplibre/:mapId" element={<MapWithId/>}/>
                <Route path="/:mapId" element={<MapboxMapWithId/>}/>
            </Routes>
        </Router>
    );
};

export default MapContainer;


const MapWithId = () => {
    const {mapId} = useParams();

    return (
        <MaplibreMapWithId mapId={mapId}/>
    );
};
